module.exports = __webpack_public_path__ + "static/media/my-account-bg.f51d2d28.jpg";